export const translatedStats = {
  "Throw In": "Arremesso Lateral",
  "Free Kick": "Falta",
  "Goal Kick": "Tiro de Meta",
  Penalty: "Pênalti",
  Substitution: "Substituição",
  Attacks: "Ataques",
  "Dangerous Attacks": "Ataques Perigosos",
  "On Target": "No Alvo",
  "Off Target": "Fora do Alvo",
  "Shots Total": "Total de Chutes",
  "Shots On Goal": "Chutes no Gol",
  "Shots Off Goal": "Chutes para Fora do Gol",
  "Shots Blocked": "Chutes Bloqueados",
  "Shots Inside Box": "Chutes dentro da Área",
  "Shots Outside Box": "Chutes fora da Área",
  Fouls: "Faltas",
  Corners: "Escanteios",
  Offsides: "Impedimentos",
  "Ball Possession": "Posse de Bola",
  "Yellow Cards": "Cartões Amarelos",
  "Red Cards": "Cartões Vermelhos",
  Saves: "Defesas",
  "Passes Total": "Passes Totais",
  "Passes Accurate": "Passes Precisos",
};

export const translatedBets = {
  "Match Corners": "Escanteios na Partida",
  "Asian Handicap": "Handicap Asiático",
  "Away Team Goals": "Gols do Time Visitante",
  "1x2 (1st Half)": "1x2 (1º Tempo)",
  "1x2 - 50 minutes": "1x2 - 50 minutos",
  "1st Goal in Interval": "1º Gol no Intervalo",
  "Over/Under (1st Half)": "Acima/Abaixo (1º Tempo)",
  "Half Time/Full Time": "Intervalo/Final do Jogo",
  "Total Corners (3way) (2nd Half)": "Total de Escanteios (3 vias) (2º Tempo)",
  "Away Team Clean Sheet": "Time Visitante Sem Sofrer Gol",
  "Race to the 5th corner?": "Corrida para o 5º Escanteio?",
  "Over/Under Line": "Acima/Abaixo da Linha",
  "To Score 3 or More": "Marcar 3 ou Mais",
  "European Handicap (1st Half)": "Handicap Europeu (1º Tempo)",
  "Final Score": "Placar Final",
  "Result / Both Teams To Score": "Resultado / Ambos Times Marcam",
  "Home Team Score a Goal (2nd Half)": "Time da Casa Marca Gol (2º Tempo)",
  "1x2 - 10 minutes": "1x2 - 10 minutos",
  "Goal Scorer": "Marcador de Gol",
  "Home Team Goals": "Gols do Time da Casa",
  "3-Way Handicap": "Handicap de 3 Vias",
  "Away Team to Score in Both Halves": "Time Visitante Marcará nos Dois Tempos",
  "Match Goals": "Gols na Partida",
  "Over/Under Line (1st Half)": "Acima/Abaixo da Linha (1º Tempo)",
  "Both Teams To Score (1st Half)": "Ambos Times Marcam (1º Tempo)",
  "Asian Handicap (1st Half)": "Handicap Asiático (1º Tempo)",
  "Asian Corners": "Escanteios Asiáticos",
  "To Win 2nd Half": "Vencer 2º Tempo",
  "Race to the 7th corner?": "Corrida para o 7º Escanteio?",
  "How many goals will Away Team score?":
    "Quantos gols o Time Visitante marcará?",
  "Which team will score the 1st goal?": "Qual time marcará o 1º gol?",
  "Race to the 9th corner?": "Corrida para o 9º Escanteio?",
  "Fulltime Result": "Resultado Final",
  "Double Chance": "Dupla Chance",
  "Home Team Clean Sheet": "Time da Casa Sem Sofrer Gol",
  "Race to the 3rd corner?": "Corrida para o 3º Escanteio?",
  "Goals Odd/Even": "Gols Ímpares/Pares",
  "Correct Score (1st Half)": "Placar Correto (1º Tempo)",
  "1x2 - 60 minutes": "1x2 - 60 minutos",
  "1x2 - 80 minutes": "1x2 - 80 minutos",
  "Next 10 Minutes Total": "Próximos 10 Minutos - Total",
  "Both Teams to Score": "Ambos Times Marcam",
  "Both Teams To Score (2nd Half)": "Ambos Times Marcam (2º Tempo)",
  "1x2 - 70 minutes": "1x2 - 70 minutos",
  "Last Corner": "Último Escanteio",
  "To Score 2 or More": "Marcar 2 ou Mais",
  "Last Team to Score (3 way)": "Último Time a Marcar (3 vias)",
  "Away 1st Goal in Interval": "Primeiro Gol Visitante no Intervalo",
  "1x2 - 20 minutes": "1x2 - 20 minutos",
  "Which team will score the 2nd corner? (2 Way)":
    "Qual time marcará o 2º escanteio? (2 vias)",
  "Home Team to Score in Both Halves": "Time da Casa Marcará nos Dois Tempos",
  "Home 1st Goal in Interval": "Primeiro Gol da Casa no Intervalo",
  "1x2 - 30 minutes": "1x2 - 30 minutos",
  "Corners Asian Handicap (1st Half)": "Handicap de Escanteios (1º Tempo)",
  "Away Team Score a Goal (2nd Half)": "Time Visitante Marca Gol (2º Tempo)",
  "Total Corners (3 way) (1st Half)": "Total de Escanteios (3 vias) (1º Tempo)",
  "1x2 - 40 minutes": "1x2 - 40 minutos",
  "Anytime Goal Scorer": "Marcador de Gol a Qualquer Momento",
  "Total Corners": "Total de Escanteios",
  "How many goals will Home Team score?":
    "Quantos gols o Time da Casa marcará?",
  "Which team will score the 4th corner? (2 Way)":
    "Qual time marcará o 4º escanteio? (2 vias)",
  "Which team will score the 5th corner? (2 Way)":
    "Qual time marcará o 5º escanteio? (2 vias)",
  "Which team will score the 6th corner? (2 Way)":
    "Qual time marcará o 6º escanteio? (2 vias)",
  "Which team will score the 7th corner? (2 Way)":
    "Qual time marcará o 7º escanteio? (2 vias)",
  "Which team will score the 8th corner? (2 Way)":
    "Qual time marcará o 8º escanteio? (2 vias)",
  "Which team will score the 10th corner? (2 Way)":
    "Qual time marcará o 10º escanteio? (2 vias)",
  "Which team will score the 11th corner? (2 Way)":
    "Qual time marcará o 11º escanteio? (2 vias)",
  "Which team will score the 12th corner? (2 Way)":
    "Qual time marcará o 12º escanteio? (2 vias)",
  "Which team will score the 13th corner? (2 Way)":
    "Qual time marcará o 13º escanteio? (2 vias)",
  "Which team will score the 14th corner? (2 Way)":
    "Qual time marcará o 14º escanteio? (2 vias)",
  "Which team will score the 15th corner? (2 Way)":
    "Qual time marcará o 15º escanteio? (2 vias)",
};

export const translatedPlayers = [
  {
    Goalkeepers: "Goleiro",
  },
];

export const betHouseOddsNames = {
  odd_1: "Vitória do time da casa",
  odd_x: "Empate",
  odd_2: "Vitória do time de fora",
  odd_1x: "Vitória do time da casa ou empate",
  odd_12: "Vitória do time da casa ou vitória do time de fora",
  odd_x2: "Empate ou Vitória do time de fora",
  "ah-4.5_1": "Handicap -4.5 para o time da casa",
  "ah-4.5_2": "Handicap -4.5 para o time de fora",
  "ah-4_1": "Handicap -4 para o time da casa",
  "ah-4_2": "Handicap -4 para o time de fora",
  "ah-3.5_1": "Handicap -3.5 para o time da casa",
  "ah-3.5_2": "Handicap -3.5 para o time de fora",
  "ah-3_1": "Handicap -3 para o time da casa",
  "ah-3_2": "Handicap -3 para o time de fora",
  "ah-2.5_1": "Handicap -2.5 para o time da casa",
  "ah-2.5_2": "Handicap -2.5 para o time de fora",
  "ah-2_1": "Handicap -2 para o time da casa",
  "ah-2_2": "Handicap -2 para o time de fora",
  "ah-1.5_1": "Handicap -1.5 para o time da casa",
  "ah-1.5_2": "Handicap -1.5 para o time de fora",
  "ah-1_1": "Handicap -1 para o time da casa",
  "ah-1_2": "Handicap -1 para o time de fora",
  ah0_1: "Handicap 0 para o time da casa",
  ah0_2: "Handicap 0 para o time de fora",
  "ah+0.5_1": "Handicap +0.5 para o time da casa",
  "ah+1_1": "Handicap +1 para o time da casa",
  "ah+1_2": "Handicap +1 para o time de fora",
  "ah+1.5_1": "Handicap +1.5 para o time da casa",
  "ah+1.5_2": "Handicap +1.5 para o time de fora",
  "ah+2_1": "Handicap +2 para o time da casa",
  "ah+2_2": "Handicap +2 para o time de fora",
  "ah+2.5_1": "Handicap +2.5 para o time da casa",
  "ah+2.5_2": "Handicap +2.5 para o time de fora",
  "ah+3_1": "Handicap +3 para o time da casa",
  "ah+3_2": "Handicap +3 para o time de fora",
  "ah+3.5_1": "Handicap +3.5 para o time da casa",
  "ah+3.5_2": "Handicap +3.5 para o time de fora",
  "ah+4_1": "Handicap +4 para o time da casa",
  "ah+4_2": "Handicap +4 para o time de fora",
  "ah+4.5_1": "Handicap +4.5 para o time da casa",
  "ah+4.5_2": "Handicap +4.5 para o time de fora",
  "o_0.5": "Mais de 0.5 Gols",
  "u_0.5": "Menos de 0.5 Gols",
  o_1: "Mais de 1 Gol",
  u_1: "Menos de 1 Gol",
  "o_1.5": "Mais de 1.5 Gols",
  "u_1.5": "Menos de 1.5 Gols",
  o_2: "Mais de 2 Gols",
  u_2: "Menos de 2 Gols",
  "o_2.5": "Mais de 2.5 Gols",
  "u_2.5": "Menos de 2.5 Gols",
  o_3: "Mais de 3 Gols",
  u_3: "Menos de 3 Gols",
  "o_3.5": "Mais de 3.5 Gols",
  "u_3.5": "Menos de 3.5 Gols",
  o_4: "Mais de 4 Gols",
  u_4: "Menos de 4 Gols",
  "o_4.5": "Mais de 4.5 Gols",
  "u_4.5": "Menos de 4.5 Gols",
  o_5: "Mais de 5 Gols",
  u_5: "Menos de 5 Gols",
  "o_5.5": "Mais de 5.5 Gols",
  "u_5.5": "Menos de 5.5 Gols",
  bts_yes: "Ambas as Equipes Marcarem - Sim",
  bts_no: "Ambas as Equipes Marcarem - Não",
};
